import { format as dateFnsFormat, getHours, getMinutes, max, min, parse } from 'date-fns';

const formatDate = (date) => {
  const today = dateFnsFormat(new Date(), 'MM/dd/yyyy');
  if (date instanceof Date && !isNaN(date)) {
    const timeStr = dateFnsFormat(date, 'HH:mm');
    return new Date(`${today} ${timeStr}`);
  } else if (!isNaN(date)) {
    const totalMs = date * 3600 * 1000;
    const tempDate = new Date(totalMs);
    const hours = String(tempDate.getUTCHours()).padStart(2, '0');
    const mins = String(tempDate.getUTCMinutes()).padStart(2, '0');
    return new Date(`${today} ${hours}:${mins}`);
  } else {
    return new Date(`${today} ${date}`);
  }
};

export const findOpenAndCloseClinicHours = (available_times) => {
  const refDate = new Date();
  let earliestTime = parse('23:59', 'HH:mm', refDate);
  let latestTime = parse('00:00', 'HH:mm', refDate);

  for (const day of available_times) {
    const endsAtLocation =
      day?.location?.ends_at !== null ? formatDate(day?.location?.ends_at) : null;
    const startsAtLocation =
      day?.location?.starts_at !== null ? formatDate(day?.location?.starts_at) : null;

    if (startsAtLocation !== null) {
      earliestTime = min([startsAtLocation, earliestTime]);
    }
    if (endsAtLocation !== null) {
      latestTime = max([endsAtLocation, latestTime]);
    }
    const endsAtVirtual = day?.virtual?.ends_at !== null ? formatDate(day?.virtual?.ends_at) : null;
    const startsAtVirtual =
      day?.virtual?.starts_at !== null ? formatDate(day?.virtual?.starts_at) : null;

    if (startsAtVirtual !== null) {
      earliestTime = min([startsAtVirtual, earliestTime]);
    }
    if (endsAtVirtual !== null) {
      latestTime = max([endsAtVirtual, latestTime]);
    }
  }
  //we do this in case there's no available_times, just to not crash the calendar view
  if (
    getHours(earliestTime) === 23 &&
    getMinutes(earliestTime) === 59 &&
    getHours(latestTime) === 0 &&
    getMinutes(latestTime) === 0
  ) {
    return {
      startsAt: {
        hour: 8,
        minute: 0
      },
      endsAt: {
        hour: 17,
        minute: 0
      }
    };
  }
  return {
    startsAt: {
      hour: getHours(earliestTime),
      minute: getMinutes(earliestTime)
    },
    endsAt: {
      hour: getHours(latestTime),
      minute: getMinutes(latestTime)
    }
  };
};
